import { isPresent } from "~/tools/is-present";
import type { NonEmptyArray } from "~/tools/non-empty-array";

export type TableColFilterIterate<TItem> = [getter: (item: TItem, query: string) => boolean, filter: TableColFilter];

export interface TableColFilterInitOptions {
	query?: string;
}

export class TableColFilter {
	public static init({ query = "" }: TableColFilterInitOptions = {}): TableColFilter {
		return new TableColFilter(query);
	}

	public static filterBy<TItem>(
		items: ReadonlyArray<TItem>,
		...entries: NonEmptyArray<TableColFilterIterate<TItem>>
	): Array<TItem> {
		const filters = entries
			.map(([getter, { query }]) => {
				const trimmed = query.trim();

				// do not filter by empty query
				if (trimmed === "") {
					return null;
				}

				return { query: trimmed, getter };
			})
			.filter(isPresent);

		return items.filter((item) => filters.every(({ query, getter }) => getter(item, query)));
	}

	private constructor(public readonly query: string) {}

	public change(value: string): TableColFilter {
		return new TableColFilter(value);
	}
}
